'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Input, _Component);

  function Input() {
    (0, _classCallCheck3.default)(this, Input);
    return (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).apply(this, arguments));
  }

  (0, _createClass3.default)(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          children = _props.children,
          styles = _props.styles;


      return _react2.default.createElement(
        'div',
        { className: 'row form-group form-inline' },
        _react2.default.createElement(
          'label',
          { className: 'col-md-2' },
          text
        ),
        _react2.default.createElement(
          'div',
          { className: styles.dataWrapper + ' col-md-7' },
          _react2.default.cloneElement(children)
        )
      );
    }
  }]);
  return Input;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.object.isRequired,
  text: _propTypes2.default.string,
  styles: _propTypes2.default.object
}, _temp);
exports.default = Input;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Input/Input.js
// module id = 861
// module chunks = 0